/**
 * Policy pages (legal.view.php): section rail and print button.
 *
 * - Marks the rail link of the section being read with aria-current, so the
 *   sticky table of contents shows where you are in a 17-section policy.
 * - Closes the mobile "Innehåll" disclosure after a jump, so the section the
 *   reader picked is what they see.
 * - Reveals the print button (hidden in the markup: without this script it
 *   would do nothing).
 * - Scrolls the current policy tab into view in the horizontally scrolling
 *   tab row.
 *
 * Everything degrades to plain anchor links without JavaScript.
 */
( function () {
	'use strict';

	function init() {
		var sections = document.querySelectorAll( '[data-policy-section]' );
		var rail = document.querySelector( '.versa-policy-rail' );

		var print = document.querySelector( '[data-policy-print]' );
		if ( print && 'function' === typeof window.print ) {
			print.hidden = false;
			print.addEventListener( 'click', function () {
				window.print();
			} );
		}

		// On a phone the current tab can sit past the right edge of the row.
		var tabs = document.querySelector( '.versa-policy-tabs' );
		var tab = tabs && tabs.querySelector( '[aria-current]' );
		if ( tab && tabs.scrollWidth > tabs.clientWidth ) {
			var left = tab.getBoundingClientRect().left - tabs.getBoundingClientRect().left + tabs.scrollLeft;
			tabs.scrollLeft = left - ( tabs.clientWidth - tab.offsetWidth ) / 2;
		}

		var toc = document.querySelector( '[data-policy-toc]' );
		if ( toc ) {
			toc.addEventListener( 'click', function ( event ) {
				if ( event.target.closest( '[data-policy-link]' ) ) {
					toc.open = false;
				}
			} );
		}

		if ( ! rail || ! sections.length ) {
			return;
		}

		var links = {};
		rail.querySelectorAll( '[data-policy-link]' ).forEach( function ( link ) {
			links[ link.getAttribute( 'href' ).slice( 1 ) ] = link;
		} );

		var current = null;
		var ticking = false;

		// An anchor jump parks a heading at scroll-margin-top + the page's
		// scroll-padding-top; a section counts as current once its heading
		// has passed a line a little below that.
		var line = 24 +
			( parseFloat( window.getComputedStyle( sections[ 0 ] ).scrollMarginTop ) || 0 ) +
			( parseFloat( window.getComputedStyle( document.documentElement ).scrollPaddingTop ) || 0 );

		function update() {
			ticking = false;
			var active = sections[ 0 ];
			for ( var i = 0; i < sections.length; i++ ) {
				if ( sections[ i ].getBoundingClientRect().top - line <= 0 ) {
					active = sections[ i ];
				} else {
					break;
				}
			}
			// At the very bottom the last sections can never reach the line.
			if ( window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2 ) {
				active = sections[ sections.length - 1 ];
			}

			var link = links[ active.id ];
			if ( link === current ) {
				return;
			}
			if ( current ) {
				current.removeAttribute( 'aria-current' );
			}
			if ( link ) {
				link.setAttribute( 'aria-current', 'location' );
				// Keep the active entry visible when the rail itself scrolls.
				var top = link.offsetTop;
				if ( top < rail.scrollTop || top > rail.scrollTop + rail.clientHeight - link.offsetHeight ) {
					rail.scrollTop = top - rail.clientHeight / 2;
				}
			}
			current = link || null;
		}

		window.addEventListener( 'scroll', function () {
			if ( ! ticking ) {
				ticking = true;
				window.requestAnimationFrame( update );
			}
		}, { passive: true } );
		window.addEventListener( 'resize', update );
		update();
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();
